import { render, staticRenderFns } from "./frameConfig.vue?vue&type=template&id=31f4a518&"
import script from "./frameConfig.vue?vue&type=script&lang=js&"
export * from "./frameConfig.vue?vue&type=script&lang=js&"
import style0 from "./frameConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports